var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('main',{staticClass:"container"},[_c('IndexInfo',{staticClass:"card-border  mb-40",attrs:{"isHome":"1"}}),_c('TokenList',{staticClass:"card-border",attrs:{"isHome":"1"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }